export const ERRORS = {
  UNKNOWN: 'Something went wrong, please reach out to an administrator.',
  CORRUPTED_DATA: 'Corrupted data',
  NOT_FOUND: 'Data was not found.',
  TOKEN_EXPIRED: 'Auth token has expired or has been invalidated',
  INVALID_CREDENTIALS: 'Email and password don\'t match. Please try again',
  TEMP_PASSWORD_PROVIDED: 'Temporary password was sent',
  MAX_ATTEMPT_EXCEEDED: 'Attempt limit exceeded, please try after some time',
}
